










































import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';

import NavItem from '@/web/components/navigation/NavItem.vue';
import { errorToMessage } from '@/core/utils/errors';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'GetResetPassword',
  components: {
    ValidationObserver,
    NavItem,
  },
  data() {
    return {
      inProgress: false,
      email: '',
      formError: null,
    };
  },
  methods: {
    async sendLink() {
      this.inProgress = true;
      try {
        const data = {
          email: this.email,
          studioURL: this.$route.meta?.isStudio
            ? getStudioURL(this.$route)
            : null,
        };

        await this.$store.dispatch('user/resetPassword', data);
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t(
            'RESET_PASSWORD.NOTIFICATIONS.PASSWORD_RESET_EMAIL_SENT_SUCCESSFULLY'
          ) as string,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
        this.$refs.form.setErrors(errorToMessage(error.response));
      }
      this.inProgress = false;
    },
  },
});
